import React, { PropTypes, Component } from 'react';
import cx from 'classnames';

class ReminderCellContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      r1clicked: false,
      r2clicked: false,
      r3clicked: false,
    };

    this.updateReminderStatus = this.updateReminderStatus.bind(this);
  }

  updateReminderStatus(triggered) {
    if (triggered === 1) {
      this.setState({
        ...this.state,
        r1clicked: true,
      });
    }
    if (triggered === 2) {
      this.setState({
        ...this.state,
        r2clicked: true,
      });
    }
    if (triggered === 3) {
      this.setState({
        ...this.state,
        r3clicked: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ invoice: nextProps.invoice });
  }

  render() {
    const { invoice } = this.props;
    const { invoiceId } = this.props;
    const { r1clicked, r2clicked, r3clicked } = this.state;

    const firstReminderStatus = cx('ui compact button', {
      green: (invoice && invoice.reminder1) || r1clicked,
    });
    const secondReminderStatus = cx('ui compact button', {
      orange: (invoice && invoice.reminder2) || r2clicked,
    });
    const thirdReminderStatus = cx('ui compact button', {
      red: (invoice && invoice.reminder3) || r3clicked,
    });

    return (
      <div className="ui buttons">
        <a
          href={`/pco-manager/invoices/${invoiceId}/reminder/1`}
          onClick={() => {
            this.updateReminderStatus(1);
          }}
          className={firstReminderStatus}
        >
          R1
        </a>
        <a
          href={`/pco-manager/invoices/${invoiceId}/reminder/2`}
          onClick={() => {
            this.updateReminderStatus(2);
          }}
          className={secondReminderStatus}
        >
          R2
        </a>
        <a
          href={`/pco-manager/invoices/${invoiceId}/reminder/3`}
          onClick={() => {
            this.updateReminderStatus(3);
          }}
          className={thirdReminderStatus}
        >
          R3
        </a>
      </div>
    );
  }
}

ReminderCellContent.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  invoice: PropTypes.object.isRequired,
};

export default ReminderCellContent;



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/workflow/components/ReminderCellContent.js